import { render, staticRenderFns } from "./DashboardWidgetAutomationWindow.vue?vue&type=template&id=3abadffc&scoped=true"
import script from "./DashboardWidgetAutomationWindow.vue?vue&type=script&lang=js"
export * from "./DashboardWidgetAutomationWindow.vue?vue&type=script&lang=js"
import style0 from "./DashboardWidgetAutomationWindow.vue?vue&type=style&index=0&id=3abadffc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abadffc",
  null
  
)

export default component.exports